import { personalizedSlipSchema } from "@redotech/redo-fulfillment-operations-common/personalized-slip/personalized-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPersonalizedSlipTemplatesByTeam = {
  name: "getPersonalizedSlipTemplatesByTeam" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(personalizedSlipSchema),
};
